export default __webpack_public_path__ + "static/media/trends.3f5a5101.svg";